// extracted by mini-css-extract-plugin
export default {"text":"Empty_text__OtNgg","title":"Empty_title__zrqOD","container":"Empty_container__IFeuV","graphic":"Empty_graphic__Ouj1i"};